module.exports = __webpack_public_path__ + "img/GREENN_SALES_BLACK.68957b04.png";